import _ from "lodash";
import { useState, useRef, useEffect, useLayoutEffect } from "react";
import { Box, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Typography, List, Grid, Paper, ListItem } from "@mui/material";
import useFetch from "../../utils/useFetch";
import SectionTemplate from "../SectionTemplate";
import Button from "../../toolkit/ButtonV1";
import { Button as Btn } from "@mui/material"
import CircledNumber from "../CircledNumber";
import CircledPencilIcon from "../../icons/CircledPencilIcon";
import ErrorAlert from "../../toolkit/ErrorAlert";
import QuestionnaireContent from "../Questionnaire/QuestionnaireContext";
import PaymentContext from "../Questionnaire/Payment/PaymentContext";
import saveData from "../../utils/saveData";
import LoadingSpinner from "../../toolkit/LoadingSpinner";
import FinalizeContext from "../Questionnaire/FinalizeContext";
import LocationContext from "../Questionnaire/Locations/LocationContext";
import SupportingDocuments from "../Questionnaire/SupportingDocuments/SupportingDocuments";
import ERIClientSelectionContext from "../Questionnaire/ERIClientSelectionContext";
import UserOrganizationContext from "../Questionnaire/UserOrganizationContext";
import SectionNote from "../Questionnaire/SectionNote";
import SectionHeaderFooter from "../Questionnaire/SectionHeaderFooter";
import { HolidayVillage, Hvac } from "@mui/icons-material";
import { getOrgType, getstatuses } from "../../utils/Token";
import EmptyComponent from "../../utils/EmptyComponent";
import Backdrop from '@mui/material/Backdrop';
import axios from "../../utils/fvAxios";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { subset } from "mathjs";
import { useContext } from "react";
import { QuestionnaireContext as QuestionnaireStore } from "../../store/questionnaire-context";
import Delayed from "../../utils/Delayed";
import LocationApproval from "../Questionnaire/LocationApproval/LocationApproval";

function getQuestionNavOptions({ id, text, status }, idx) {
  return {
    id,
    text,
    status,
    leadingComponent: <CircledNumber num={idx + 1} />,
  };
}

function getComponent(name) {
  switch (name) {
    case "":
    case "ClientSign":
    case "VendorSign":
    case "BiddingReporting":
    case "SubSectionReport":
    case "ProductCategoriesReporting":
    case "ProficiencyReporting":
    case "ClaycoBiddingReporting":
    case "YearWiseStats":
      return QuestionnaireContent;
    case "SitePrequalification":
      return LocationContext;
    case "LocationApproval":
      return LocationApproval;
    case "SupportingDocument":
      return SupportingDocuments;
    case "PrequalificationPayment":
      return PaymentContext;
    case "PrequalificationFinalize":
      return FinalizeContext;
    case "ERIClientSelection":
      return ERIClientSelectionContext;
    case "UserDetailsForEP": //new one add here!
    case "UserOrganization":
      return UserOrganizationContext;
    case "SectionHeader":
    case "SectionFooter":
      return SectionHeaderFooter;
    case "PrequalComments":
      return EmptyComponent;
    default:
      return EmptyComponent;
  }
}

const toastNotify = (message, isSuccess = true) => {
  if (isSuccess) {
    toast.success(message, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  } else {
    toast.error(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  }
};

export default function QuestionnaireSubSectionList({
  dataUrl,
  Secid,
  SecName,
  selected,
  SectionType,
  IsSectionCompleted,
  HeaderTitle,
  FooterTitle,
  HeaderContent,
  FooterContent,
  SectionFooterTitle,
  setNextSection,
  FinalizePopUpOpen,
  PqStatusID,
  VIEWMODE,
  PQCLIENTID,
  ClientTemplate,
  pqid,
  languageId,
  venName,
  pqStartDate,
  pqClientVendorRef,
  PqClientName,
  IsMultiple,
  dataload,// ABDUL FEE CAP END
  LocationSectionReset,
  LastSectionId,
  CurrSectionId
}) {
  const [Refresh, setRefresh] = useState(true);
  const params = new URLSearchParams(window.location.search);
  const _pqid = params?.get("pqid");
  const isMultiClientId = params.get("ClientId");
  const SubSectionID = params?.get("subsectionid");
  const PQID = pqid ?? _pqid;
  const {
    data: resp,
    loading,
    error,
  } = useFetch(
    "/Prequalification/PqSubSections?pqId=" +
    PQID +
    "&sectionId=" +
    Secid +
    "&Refresh=" +
    Refresh
  ); // TODO: We Add Extra Perameter  "Refresh"
  const subSectionTabsRef = useRef(null);
  const [subSectionId, setSubSectionId] = useState(selected);
  const [subSection, setSubSection] = useState();
  const [subSections, setSubSections] = useState([]);
  const [NextId, setNextId] = useState();
  const [subSectionsAPIList, setSubSectionsAPIList] = useState([]);
  const [refreshSubSection, setRefreshSubSection] = useState(false);
  const [subSectionNavProps, setSubSectionNavProps] = useState({
    options: subSections?.map(getQuestionNavOptions),
    // onChange: setSubSectionId,
    onChange: (subSectionId) => {
      setSubSectionId(null);
      setSubSectionId(subSectionId);
      setResetButtons(!resetButtons);
    },
    // onChange: (id) => setSubSectionId(String(id)),
    refFromParent: subSectionTabsRef,
  });
  const [disabledButtons, setDisabledButtons] = useState({
    save: true,
    cancel: true,
  });


  const [SaveButtionHiden, setSaveButtionHiden] = useState(true);

  const [scrollTabIntoView, setScrollTabIntoView] = useState(false);
  const [saveState, setSaveState] = useState({});
  const [showFormButtons, setShowFormButtons] = useState(false);
  const [modifiedData, setModifiedData] = useState({});
  const [reset, setReset] = useState(false);
  const [questionReset, setQuestionReset] = useState(false);
  const [skippedPayment, setskippedPayment] = useState(false);
  const [skippedPayment1, setskippedPayment1] = useState(false);
  const [skippedPayment2, setskippedPayment2] = useState(false);
  const [updateSubSectionsVisibility, setUpdateSubSectionsVisibility] =
    useState(false);

  const [Information, setInformation] = useState({});

  const [resetButtons, setResetButtons] = useState(true);
  const [showResetConfirm, setShowResetConfirm] = useState(false);//Clear Form
  const [ClearForm, setClearForm] = useState(false);//Clear Form
  const [Loder, setLoder] = useState(false);

  const [ResetQuestions, setResetQuestions] = useState(false);
  const questionnaireStore = useContext(QuestionnaireStore);
  const [fieldIdsAndInputTypes, setFieldIdsAndInputTypes] = useState([]);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(
    !!Object.keys(modifiedData)?.length
  );
  const [eriUserResponse, setEriUserResponse] = useState({});
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    setSubSection(subSections?.find((s) => s?.id === subSectionId));
  }, [subSectionId, refreshSubSection]);

  useEffect(() => {
    setSubSectionNavProps((prev) => ({
      ...prev,
      options: subSections
        ?.filter((subSection) => !subSection?.isHide)
        ?.map(getQuestionNavOptions),
    }));
    questionnaireStore?.currentSubSectionId > 0 &&
      subSections?.some((x) => x?.id == questionnaireStore?.currentSubSectionId)
      ? setSubSectionId(questionnaireStore?.currentSubSectionId)
      : setSubSectionId(subSections?.[0]?.id);
    setRefreshSubSection({});
    setUpdateSubSectionsVisibility(false);
  }, [subSections, updateSubSectionsVisibility]);

  useEffect(() => {
    if (resp?.data) {
      resp?.data?.forEach(
        (q) => (q.component = getComponent(q?.subSectionTypeCondition))
      ); //Todo: Handle sub section based content
      var subsections = GetSubsectionsList(resp?.data);
      // setSubSectionsAPIList(subsections);
      //  setSubSections(subsections.filter(r=>!r.isHide));
      setSubSections(subsections);
    }
  }, [resp]);




  function GetSubsectionsList(data) {
    var res = [];
    // if (HeaderTitle && HeaderContent) {
    //   res.push({
    //     id: -1,
    //     text: "Header",
    //     status: "completed",
    //     SubsectiontypeCondition: "SectionHeader",
    //     component: getComponent("SectionHeader"),
    //     subSectionNotes: '',
    //     title: HeaderTitle,
    //     content: HeaderContent

    //   });
    // }

    res.push(
      ...data?.map((r) => ({
        id: r?.subSectionId,
        text: r?.subSectionName,
        status: r?.isSubSectionCompleted === true ? "completed" : "pending",
        SubsectiontypeCondition: r?.subSectionTypeCondition,
        isSubSectionCompleted: r?.isSubSectionCompleted,
        component: r?.component,
        subSectionNotes: r?.subSectionNotes,
        isHide: r?.isHide,
        editAccess: r?.isEdit
      }))
    );

    // if (FooterTitle && FooterContent) {
    //   res.push({
    //     id: 1,
    //     text: "Footer",
    //     status: "completed",
    //     SubsectiontypeCondition: "SectionFooter",
    //     component: getComponent("SectionFooter"),
    //     subSectionNotes: '',
    //     title: FooterTitle,
    //     content: FooterContent
    //   });
    // }

    return res;
  }


  var SubSecId = subSectionId;
  if (!SubSecId) SubSecId = SubSectionID;
  const newURL = window.location.pathname + `?pqid=${PQID}&ClientId=${isMultiClientId}&sectionid=${Secid}&subSectionid=${SubSecId}`;
  window.history.pushState({}, "", newURL);


  useEffect(() => {
    const subSectionIds = (subSections || [])?.map((f) => f.id);
    const idx = subSectionIds?.indexOf(subSection?.id);
    if (saveState?.status === "inProgress") {
      setDisabledButtons({
        prev: true,
        next: true,
        cancel: true,
        save: true
      });
    } else {
      setDisabledButtons({
        prev: idx <= 0 || hasUnsavedChanges,
        next: idx == subSectionIds?.length - 1 || hasUnsavedChanges,
        cancel: !hasUnsavedChanges,
        save: !hasUnsavedChanges
      });
    }
  }, [subSection, saveState, hasUnsavedChanges]);

  useEffect(() => {
    setHasUnsavedChanges(true);
  }, [eriUserResponse]);
  const [Reloader, setReloader] = useState();
  // useEffect(() => {
  //   if(subSectionId&&Reloader==true)
  //   window.location.reload()
  // debugger;
  // }, [subSectionId,Reloader]);
  useEffect(() => {
    setHasUnsavedChanges(!!Object.keys(modifiedData)?.length);
  }, [modifiedData]);

  useLayoutEffect(() => {
    if (scrollTabIntoView) {
      const subSectionIds = (subSections || [])?.map((f) => f?.id);
      const idx = subSectionIds?.indexOf(subSection?.id);
      subSectionTabsRef?.current?.children[idx]?.scrollIntoView();
      setScrollTabIntoView(false);
      // setReset(true);
    }
  }, [subSection, scrollTabIntoView]);

  function hideCompleteAndContinue(type) {
    let subsections = [
      "SitePrequalification",
      "LocationApproval",
      "PrequalificationFinalize",
      "PrequalificationPayment",
      "SupportingDocument",
      "UserDetailsForEP",
      "UserOrganization",
      // "ERIClientSelection"
    ];
    if (!type) {
      type = "";
    }
    return subsections?.indexOf(type) != -1;
  }

  // function setPrevActive() {
  //   const visibleSections = subSections.filter((x) => x.isHide === false);
  //   const cur = visibleSections.find((f) => f.id === subSection.id);
  //   const prev = visibleSections[visibleSections.indexOf(cur) - 1];
  //   if (prev) {
  //     setScrollTabIntoView(true);
  //     setSubSectionId(prev.id);
  //   }
  // }

  // function setNextActive() {
  //   const visibleSections = subSections.filter((x) => x.isHide === false);
  //   const cur = visibleSections.find((f) => f.id == subSection.id);
  //   const next = visibleSections[visibleSections.indexOf(cur) + 1];
  //   const allSectionsCompleted = visibleSections.every(
  //     (section) => section.isSubSectionCompleted === true
  //   );

  //   setSubSectionId(null);
  //   if (next) {
  //     setScrollTabIntoView(true);
  //     setSubSectionId(next.id);
  //   } else {
  //     setNextSection(allSectionsCompleted);
  //   }
  // }
  // const [required, setRequired] = useState();
  const [validate, setValidate] = useState({});
  const [TotPay, setTotPay] = useState(null);
  const [Paymentdone, setTpaymentdone] = useState({});
  const [hasLocationData, setHasLocationData] = useState(false);
  // const [Val, setVal] = useState(true);




  const ValidationsErrors = (columnId, value, subfield = 0) => {
    setValidate((prevValidate) => ({
      ...prevValidate,
      [columnId]:
        subfield !== 0
          ? {
            ...prevValidate[columnId],
            [subfield]: value,
          }
          : value,
    }));
  };

  const RemoveRequiredHiddenFields = (columnId, value, subfield = 0) => {
    setValidate((prevValidate) => {
      const updatedPrevValidate = { ...prevValidate };
      if (updatedPrevValidate[columnId] != undefined) {
        // Filter out the subfield if it's not 0
        if (subfield !== 0) {
          delete updatedPrevValidate[columnId][subfield];
        } else {
          // If subfield is 0, remove the entire columnId
          delete updatedPrevValidate[columnId];
        }
      }
      return updatedPrevValidate;
    });
  };

  const validateAllSubSectionQuestions = (data) => {
    setValidate({});
    const updatedFieldIdsAndInputTypes = [];
    data?.forEach((question) => {
      question?.forEach((field) => {
        if (field?.required && !field?.hidden) {
          const formulafieldcheck = field?.subFields
            ?.filter((x) => x?.qFormula != null)?.length == 0

          // let subFieldData = field?.subFields
          //   ?.filter((x) => x.qFormula != null)             
          //   .map((y) => y.qFormula);
          // if (subFieldData?.length == 0) {
          //   ValidationsErrors(field.id, field.userResponse);     
          // } 
          // ValidationsErrors(field.id, field.userResponse); 
          if (field?.subFields) {
            let subFieldData = field?.subFields
              ?.filter((x) => x?.qFormula != null)
              ?.map((y) => y?.qFormula);
            if (subFieldData?.length == 0) {
              ValidationsErrors(field?.id, field?.userResponse);      // Note:- code before form validation were applyied
            }
          }
          else {
            ValidationsErrors(field?.id, field?.userResponse)
          }

        }
        updatedFieldIdsAndInputTypes.push({
          fieldId: field?.id,
          subFieldId: 0,
          inputType: field?.inputType,
          field: { ...field },
        });
        field?.subFields?.forEach((subField) => {
          if (subField?.inputType !== "button") {
            updatedFieldIdsAndInputTypes?.push({
              fieldId: field?.id,
              subFieldId: subField?.id,
              inputType: subField?.inputType,
              field: { ...field },
            });
            if (field?.required && !field?.hidden && !subField?.qFormula)
              ValidationsErrors(field?.id, subField?.userResponse, subField?.id);
          }
        });
      });
    });
    setFieldIdsAndInputTypes(updatedFieldIdsAndInputTypes);
  };
  const navigate = useNavigate();

  const validateUserInputs = (key, topLevelValue) => {
    const isEmpty = (value) =>
      value === null ||
      value === undefined ||
      value === "" ||
      (typeof value === "string" && value.trim() === "");
    const hasNonEmptyValue = (array) => array?.some((item) => !isEmpty(item));
    const field = fieldIdsAndInputTypes?.find((x) => x?.fieldId == key)?.field;
    if (topLevelValue && topLevelValue != "" && field?.inputType === "checkbox")
      topLevelValue = JSON?.parse(String(topLevelValue)?.toLowerCase());
    if (topLevelValue && typeof topLevelValue === "string") {
      return !isEmpty(topLevelValue);
    } else if (topLevelValue && Array.isArray(topLevelValue)) {
      return hasNonEmptyValue(topLevelValue);
    } else if (
      topLevelValue &&
      typeof topLevelValue === "boolean" &&
      field?.inputType === "checkbox"
    ) {
      return topLevelValue;
    } else if (topLevelValue && isEmpty(topLevelValue)) {
      return true;
    } else if (topLevelValue && typeof topLevelValue === "object") {
      return Object.values(topLevelValue)?.every((subfieldValue) => {
        return validateUserInputs(key, subfieldValue);
      });
    }
  };

  const isFieldsValidated = () => {
    let isValid = true;
    let isEmailValid = true;
    let isPhoneValid = true;
    let regEmail = /^[ ]*([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})[ ]*$/i;
    let regphone = /^\(\d{3}\) \d{3}-\d{4}$/;
    for (const key of Object.keys(validate)) {
      const field = fieldIdsAndInputTypes?.find((x) => x?.fieldId == key)?.field;
      if (validate[key] && typeof validate[key] === "string") {
        isValid = validateUserInputs(key, validate[key]);
        if (isValid && field?.inputType === "email") {
          isEmailValid = regEmail?.test(validate[key]);
        }
        if (isValid && field?.inputType === "tel") {
          isPhoneValid = regphone?.test(validate[key]);
        }
      } else {
        isValid = validateUserInputs(key, validate[key]);
      }
      if (!isValid) {
        toastNotify("Please fill all required fields", false);
        break;
      } else if (isValid && !isEmailValid) {
        toastNotify("Invalid Email Address", false);
        break;
      } else if (isValid && !isPhoneValid) {
        toastNotify("Invalid format. Use like (000) 000-0000", false);
        break;
      }
    }

    return (isValid === isEmailValid) === isPhoneValid;
  };
  const [WithoutmodifiedData, setWithoutmodifiedData] = useState({});


  const [OpenPopup, setOpenPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");

  const formatBlockedEmailMessage = (message) => {
    if (!message) return null;
    const blockedMatch = message?.match(/BlockedEmails:\s*\(\s*(.*?)\s*\)/);
    const unBlockedMatch = message?.match(/UnBlockedEmails:\s*\(\s*(.*?)\s*\)/);

    return {
      description:
        "Some recipients could not be processed because their email addresses are blocked. The remaining recipients will receive the email.",
      blockedEmails: blockedMatch?.[1]
        ?.split(",")
        ?.map(x => x.trim())
        ?.filter(Boolean) || [],
      unBlockedEmails: unBlockedMatch?.[1]
        ?.split(",")
        ?.map(x => x.trim())
        ?.filter(Boolean) || []
    };
  };

  const [pendingAction, setPendingAction] = useState(null);

  const moveToNext = () => {
    const visibleSections = subSections?.filter((x) => x?.isHide === false);
    const cur = visibleSections?.find((f) => f?.id === subSection?.id);
    let next = visibleSections[visibleSections?.indexOf(cur) + 1];

    setSubSectionId(null);

    if (next) {
      setScrollTabIntoView(true);
      setSubSectionId(next?.id);
      setNextId(next?.id);
      setResetButtons(!resetButtons);
      questionnaireStore?.setCurrentSubSectionId(next?.id);
      setRefresh(!Refresh);
    } else {
      setNextSection(true);
      if (LastSectionId == CurrSectionId && SectionType == 34) {
        setResetButtons(!resetButtons);
        setNextSection(false);
      }
    }
  };


  function SaveContinue() {
    setLoder(true);
    if (subSections[subSections?.length - 1]?.id == subSectionId && SectionType == 34) {
      setLoder(true);
      setTimeout(() => {
        if (isFieldsValidated()) {
          (async () => {
            let subSectionDetail = subSections?.find((r) => r?.id == subSectionId);
            let isSubsectionCompleted = subSectionDetail?.isSubSectionCompleted;
            let subSectionType = subSectionDetail?.SubsectiontypeCondition;
            let details = [];
            let Info = []; // with out changes any fields
            if (subSectionType == "ERIClientSelection") {
              if (
                eriUserResponse?.lockedClients?.length == 0 &&
                eriUserResponse?.unLockedClients?.length == 0
              ) {
                setShowPrompt(true);
                return;
              }

              details?.push({
                subSectionId: subSectionId,
                isSubSectionCompleted: isSubsectionCompleted,
                subSectionTypeCondition: subSectionType,
                isFinancialAnalytics: true,
                userInputsList: eriUserResponse?.unLockedClients?.map((r) => {
                  return {
                    UserInputRecId: 0,
                    questionColumnId: 0,
                    userInput: r?.value,
                    oldUserInput: "",
                    referenceid: 0,
                  };
                }),
              });
            } else {
              // with out changes any fields
              Info = WithoutmodifiedData?.subSectionDetails?.map((r) => {
                return {
                  subSectionId: r?.subSectionid,
                  isSubSectionCompleted: isSubsectionCompleted,
                  subSectionTypeCondition: r?.subSectionTypeCondition,
                  isFinancialAnalytics: true,
                  userInputsList: r?.subSectionQuestions?.flatMap((r) =>
                    r?.questionColumns?.flatMap((r) => {
                      return {
                        UserInputRecId: r?.preQualRecId,
                        questionColumnId: r?.columnId,
                        userInput: r?.answer,
                        oldUserInput: "",
                        referenceid: 0,
                      };
                    })
                  ),
                };
              });

              details = modifiedData?.data?.subSectionDetails?.map((r) => {
                return {
                  subSectionId: r?.subSectionid,
                  isSubSectionCompleted: isSubsectionCompleted,
                  subSectionTypeCondition: r?.subSectionTypeCondition,
                  isFinancialAnalytics: true,
                  userInputsList: r?.subSectionQuestions.flatMap((r) =>
                    r.questionColumns.flatMap((r) => {
                      return {
                        UserInputRecId: r?.preQualRecId,
                        questionColumnId: r?.columnId,
                        userInput: r?.answer,
                        oldUserInput: "",
                        referenceid: 0,
                      };
                    })
                  ),
                };
              });
            }
            setSaveState({ status: "inProgress" });
            let _pqId = +PQID;
            if (_pqId === 0) {
              _pqId = +params.get("pqid");
              if (_pqId === 0) {
                alert("Invalid PqId");
                return;
              }
            }

            const pqUserInputVModel = {
              insertType: 2,
              preQualificationId: +PQID, //TODO:-- Convert String to Integer
              isSectionCompleted: IsSectionCompleted,
              sectionID: Secid,
              sectionType: SectionType,
              userInputsModelList: !hasUnsavedChanges ? Info : details,
            };

            const saveResp = await axios.post(
              "Prequalification/SaveUserInputForPQ",
              pqUserInputVModel
            );
            setSaveState(saveResp);
            const text = saveResp?.data?.data;
            const visibleSections = subSections?.filter((x) => x?.isHide === false);
            const cur = visibleSections?.find((f) => f?.id === subSection?.id);
            let next = visibleSections[visibleSections?.indexOf(cur) + 1];

            if (text == "Success") {
              toast.success(text, {
                position: "top-right",
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
              setLoder(false);
              moveToNext();

              //setSubSectionId(null);
              // if (next) {
              //   // setRefresh(!Refresh);
              //   setScrollTabIntoView(true);
              //   setSubSectionId(next?.id);
              //   setNextId(next?.id);
              //   setResetButtons(!resetButtons);
              //   questionnaireStore?.setCurrentSubSectionId(next?.id); //store next id in context API
              //   setRefresh(!Refresh);
              // } else {
              //   setNextSection(true);
              //   if (LastSectionId == CurrSectionId && SectionType == 34) {
              //     setResetButtons(!resetButtons);
              //     setNextSection(false); //Refresh Sections
              //   }
              // }

            } else {

              const hasBlockedEmails = text?.includes("BlockedEmails:");
              const isInvalidEmail = text == "Invalid Email";

              if (hasBlockedEmails || isInvalidEmail) {
                if (hasBlockedEmails) {
                  setPopupMessage(formatBlockedEmailMessage(text));

                  setPendingAction(() => () => {
                    moveToNext();   // your existing navigation code
                  });

                  setOpenPopup(true);
                  setLoder(false);
                  return; // Stop only for BlockedEmails
                }

                if (isInvalidEmail) {
                  toast.error(
                    "Unable to send the email because the recipient's email address is invalid or blocked.",
                    {
                      position: "top-right",
                      autoClose: 4000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                      theme: "light",
                    }
                  );
                }
                setLoder(false);
                moveToNext();


                // setSubSectionId(null);
                // if (next) {
                //   // setRefresh(!Refresh);
                //   setScrollTabIntoView(true);
                //   setSubSectionId(next?.id);
                //   setNextId(next?.id);
                //   setResetButtons(!resetButtons);
                //   questionnaireStore?.setCurrentSubSectionId(next?.id); //store next id in context API
                //   // refresh subsections
                //   setRefresh(!Refresh);

                //   // setQuestionReset(!questionReset);
                //   //setRefresh(!Refresh);  //TODO:i add code here!
                // } else {
                //   setTimeout(() => {
                //     setNextSection(true);
                //     if (LastSectionId == CurrSectionId && SectionType == 34) {
                //       setResetButtons(!resetButtons);
                //       setNextSection(false); //Refresh Sections
                //     }
                //   }, 3000);
                // }

              } else {
                toast.error(text, {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                });
              }
              setLoder(false);
            }
          })();
        } else {
          setLoder(false);
        }
      }, 200);
      return;
    } else {
      if (isFieldsValidated()) {
        (async () => {
          let subSectionDetail = subSections?.find((r) => r?.id == subSectionId);
          let isSubsectionCompleted = subSectionDetail?.isSubSectionCompleted;
          let subSectionType = subSectionDetail?.SubsectiontypeCondition;
          let details = [];
          let Info = []; // with out changes any fields
          if (subSectionType == "ERIClientSelection") {
            if (
              eriUserResponse?.lockedClients?.length == 0 &&
              eriUserResponse?.unLockedClients?.length == 0
            ) {
              setShowPrompt(true);
              return;
            }

            details?.push({
              subSectionId: subSectionId,
              isSubSectionCompleted: isSubsectionCompleted,
              subSectionTypeCondition: subSectionType,
              isFinancialAnalytics: true,
              userInputsList: eriUserResponse?.unLockedClients?.map((r) => {
                return {
                  UserInputRecId: 0,
                  questionColumnId: 0,
                  userInput: r?.value,
                  oldUserInput: "",
                  referenceid: 0,
                };
              }),
            });
          } else {
            // with out changes any fields
            Info = WithoutmodifiedData?.subSectionDetails?.map((r) => {
              return {
                subSectionId: r?.subSectionid,
                isSubSectionCompleted: isSubsectionCompleted,
                subSectionTypeCondition: r?.subSectionTypeCondition,
                isFinancialAnalytics: true,
                userInputsList: r?.subSectionQuestions?.flatMap((r) =>
                  r?.questionColumns?.flatMap((r) => {
                    return {
                      UserInputRecId: r?.preQualRecId,
                      questionColumnId: r?.columnId,
                      userInput: r?.answer,
                      oldUserInput: "",
                      referenceid: 0,
                    };
                  })
                ),
              };
            });

            details = modifiedData?.data?.subSectionDetails?.map((r) => {
              return {
                subSectionId: r?.subSectionid,
                isSubSectionCompleted: isSubsectionCompleted,
                subSectionTypeCondition: r?.subSectionTypeCondition,
                isFinancialAnalytics: true,
                userInputsList: r?.subSectionQuestions?.flatMap((r) =>
                  r?.questionColumns?.flatMap((r) => {
                    return {
                      UserInputRecId: r?.preQualRecId,
                      questionColumnId: r?.columnId,
                      userInput: r?.answer,
                      oldUserInput: "",
                      referenceid: 0,
                    };
                  })
                ),
              };
            });
          }
          setSaveState({ status: "inProgress" });
          let _pqId = +PQID;
          if (_pqId === 0) {
            _pqId = +params.get("pqid");
            if (_pqId === 0) {
              alert("Invalid PqId");
              return;
            }
          }

          const pqUserInputVModel = {
            insertType: 2,
            preQualificationId: +PQID, //TODO:-- Convert String to Integer
            isSectionCompleted: IsSectionCompleted,
            sectionID: Secid,
            sectionType: SectionType,
            userInputsModelList: !hasUnsavedChanges ? Info : details,
          };

          const saveResp = await axios.post(
            "Prequalification/SaveUserInputForPQ",
            pqUserInputVModel
          );
          setSaveState(saveResp);
          const text = saveResp?.data?.data;
          const visibleSections = subSections?.filter((x) => x?.isHide === false);
          const cur = visibleSections?.find((f) => f?.id === subSection?.id);
          let next = visibleSections[visibleSections?.indexOf(cur) + 1];

          if (text == "Success") {

            toast.success(text, {
              position: "top-right",
              autoClose: 4000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });

            setLoder(false);
            moveToNext();

            // setSubSectionId(null);
            // if (next) {
            //   setScrollTabIntoView(true);
            //   setSubSectionId(next?.id);
            //   setNextId(next?.id);
            //   setResetButtons(!resetButtons);
            //   questionnaireStore?.setCurrentSubSectionId(next?.id); //store next id in context API
            //   setRefresh(!Refresh);
            // } else {
            //   setNextSection(true);
            //   if (LastSectionId == CurrSectionId && SectionType == 34) {
            //     setResetButtons(!resetButtons);
            //     setNextSection(false); //Refresh Sections
            //   }

            // }
          } else {

            const hasBlockedEmails = text?.includes("BlockedEmails:");
            const isInvalidEmail = text == "Invalid Email";

            if (hasBlockedEmails || isInvalidEmail) {

              if (hasBlockedEmails) {
                setPopupMessage(formatBlockedEmailMessage(text));

                setPendingAction(() => () => {
                  moveToNext();   // your existing navigation code
                });

                setOpenPopup(true);
                setLoder(false);
                return; // Stop only for BlockedEmails
              }

              if (isInvalidEmail) {
                toast.error(
                  "Unable to send the email because the recipient's email address is invalid or blocked.",
                  {
                    position: "top-right",
                    autoClose: 4000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    theme: "light",
                  }
                );
              }

              setLoder(false);
              moveToNext();

              // setSubSectionId(null);
              // if (next) {
              //   // setRefresh(!Refresh);
              //   setScrollTabIntoView(true);
              //   setSubSectionId(next?.id);
              //   setNextId(next?.id);
              //   setResetButtons(!resetButtons);
              //   questionnaireStore?.setCurrentSubSectionId(next?.id); //store next id in context API
              //   // refresh subsections
              //   setRefresh(!Refresh);

              //   // setQuestionReset(!questionReset);
              //   //setRefresh(!Refresh);  //TODO:i add code here!
              // } else {
              //   setTimeout(() => {
              //     setNextSection(true);
              //     if (LastSectionId == CurrSectionId && SectionType == 34) {
              //       setResetButtons(!resetButtons);
              //       setNextSection(false); //Refresh Sections
              //     }
              //   }, 3000);
              // }

            } else {
              toast.error(text, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
            }
            setLoder(false);
          }
        })();
      } else {
        setLoder(false);
      }
    }

  }
  const [ClientIds, setClientIds] = useState();


  function EmptyPqComments() {
    setLoder(true);
    (async () => {
      let subSectionDetail = subSections?.find((r) => r?.id == subSectionId);
      let isSubsectionCompleted = subSectionDetail?.isSubSectionCompleted;
      let subSectionType = subSectionDetail?.SubsectiontypeCondition;
      setSaveState({ status: "inProgress" });
      let _pqId = +PQID;
      if (_pqId === 0) {
        _pqId = +params.get("pqid");
        if (_pqId === 0) {
          alert("Invalid PqId");
          return;
        }
      }

      const pqUserInputVModel = {
        insertType: 2,
        preQualificationId: +PQID, //TODO:-- Convert String to Integer
        isSectionCompleted: IsSectionCompleted,
        sectionID: Secid,
        sectionType: SectionType,
        userInputsModelList: [{
          subSectionId: subSectionId,
          isSubSectionCompleted: isSubsectionCompleted,
          subSectionTypeCondition: subSectionType,
          isFinancialAnalytics: true,
          userInputsList: []
        }]
      };

      const saveResp = await axios.post(
        "Prequalification/SaveUserInputForPQ",
        pqUserInputVModel
      );
      setSaveState(saveResp);
      const text = saveResp?.data?.data;
      const visibleSections = subSections?.filter((x) => x?.isHide === false);
      const cur = visibleSections?.find((f) => f?.id === subSection?.id);
      let next = visibleSections[visibleSections?.indexOf(cur) + 1];

      const moveToNext = () => {
        setSubSectionId(null);
        if (next) {
          setScrollTabIntoView(true);
          setSubSectionId(next?.id);
          setNextId(next?.id);
          setResetButtons(!resetButtons);
          questionnaireStore?.setCurrentSubSectionId(next?.id);
          setRefresh(!Refresh);
        } else {
          setNextSection(true);
        }
      };

      //setSubSectionId(null);
      if (text == "Success") {
        //setSubSectionId(null);
        toast.success(text, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setLoder(false);
        moveToNext();

        // if (next) {
        //   setScrollTabIntoView(true);
        //   setSubSectionId(next?.id);
        //   setNextId(next?.id);
        //   setResetButtons(!resetButtons);
        //   questionnaireStore?.setCurrentSubSectionId(next?.id); //store next id in context API
        //   setRefresh(!Refresh);
        // } else {
        //   setNextSection(true); //Refresh Sections
        // }

      } else {
        const hasBlockedEmails = text?.includes("BlockedEmails:");
        const isInvalidEmail = text == "Invalid Email";

        if (hasBlockedEmails || isInvalidEmail) {

          // Wait for OK button
          if (hasBlockedEmails) {
            setPopupMessage(formatBlockedEmailMessage(text));

            setPendingAction(() => () => {
              moveToNext();
            });

            setOpenPopup(true);
            setLoder(false);
            return;
          }

          if (isInvalidEmail) {
            toast.error(
              "Unable to send the email because the recipient's email address is invalid or blocked.",
              {
                position: "top-right",
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: "light",
              }
            );
          }
          setLoder(false);
          moveToNext();

          // setSubSectionId(null);
          // if (next) {
          //   setScrollTabIntoView(true);
          //   setSubSectionId(next?.id);
          //   setNextId(next?.id);
          //   setResetButtons(!resetButtons);
          //   questionnaireStore?.setCurrentSubSectionId(next?.id); //store next id in context API
          //   // refresh subsections
          //   setRefresh(!Refresh);
          // } else {
          //   setNextSection(true); //Refresh Sections
          // }

        } else {
          toast.error(text, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
        setLoder(false);
      }
    })();
  }

  const [NewInfo, setNewInfo] = useState([]);
  const [PqUserRequest, setPqUserRequest] = useState();
  const [isSaved, setIsSaved] = useState(false);

  function Save(val) {
    setLoder(true);
    val = +val;
    if (val === 1) {
      if (!isFieldsValidated()) {
        setLoder(false);
        return false;
      }
    }
    setSaveState({ status: "inProgress" });
    (async () => {
      let subSectionDetail = subSections?.find((r) => r?.id == subSectionId);
      let isSubsectionCompleted = subSectionDetail?.isSubSectionCompleted;
      let subSectionType = subSectionDetail?.SubsectiontypeCondition;
      let details = [];
      if (subSectionType == "ERIClientSelection") {
        details.push({
          subSectionId: 0,
          isSubSectionCompleted: isSubsectionCompleted,
          subSectionTypeCondition: subSectionType,
          isFinancialAnalytics: true,
          userInputsList: eriUserResponse?.unLockedClients?.map((r) => {
            return {
              UserInputRecId: 0,
              questionColumnId: 0,
              userInput: r?.value,
              oldUserInput: "",
              referenceid: 0,
            };
          }),
        });
      } else {
        details = modifiedData?.data?.subSectionDetails?.map((r) => {
          return {
            subSectionId: r?.subSectionid,
            isSubSectionCompleted: isSubsectionCompleted,
            subSectionTypeCondition: r?.subSectionTypeCondition,
            isFinancialAnalytics: true,
            userInputsList: r?.subSectionQuestions?.flatMap((r) =>
              r?.questionColumns?.flatMap((r) => {
                return {
                  UserInputRecId: r?.preQualRecId,
                  questionColumnId: r?.columnId,
                  userInput: r?.answer,
                  oldUserInput: "",
                  referenceid: 0,
                };
              })
            ),
          };
        });
      }

      let _pqId = +PQID;
      if (_pqId === 0) {
        _pqId = +params.get("pqid");
        if (_pqId === 0) {
          alert("Invalid PqId");
          return;
        }
      }

      const pqUserInputVModel = {
        insertType: 1,
        preQualificationId: _pqId, //TODO:-- Convert String to Integer
        isSectionCompleted: IsSectionCompleted,
        sectionID: Secid,
        sectionType: SectionType,
        isNotifyFV: val == 1 ? true : false,
        userInputsModelList: details,
      };

      const saveResp = await axios.post(
        "Prequalification/SaveUserInputForPQ",
        pqUserInputVModel
      );
      setSaveState(saveResp?.data?.data);

      const afterSave = () => {
        setPqUserRequest(true);
        setResetButtons(!resetButtons);
        setNewInfo(modifiedData);
        setIsSaved(true);

        setTimeout(() => {
          setIsSaved(false);
        }, 6000);
      };

      if (saveResp?.data?.data == "Saved Successfully" || saveResp?.data?.data == "Success") {
        toast.success(saveResp?.data?.data, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });

        setLoder(false);
        afterSave();

        //when create  new priqualification  after save first time i all the Api
        // const PQUswrInputIds = modifiedData?.data?.subSectionDetails.map((r) => r?.subSectionQuestions.flatMap((r) => r.questionColumns.flatMap((r) => {
        //   return {
        //     UserInputRecId: r?.preQualRecId
        //   };
        // })))
        // let PQUswrInputIdsInfo = false;
        // for (let i = 0; i < PQUswrInputIds?.length; i++) {
        //   PQUswrInputIdsInfo = PQUswrInputIds[i]?.find((r) => r?.UserInputRecId == 0) ? true : false;
        //   if (PQUswrInputIdsInfo) { break; }
        // }

        //newly cominted code
        // setPqUserRequest(true);
        // setResetButtons(!resetButtons);
        // setNewInfo(modifiedData);
        // setIsSaved(true);
        // setTimeout(() => {
        //   setIsSaved(false);
        // }, 6000)
      } else {
        const hasBlockedEmails = saveResp?.data?.data?.includes("BlockedEmails:");
        const isInvalidEmail = saveResp?.data?.data == "Invalid Email";

        if (hasBlockedEmails || isInvalidEmail) {

          if (hasBlockedEmails) {
            setPopupMessage(formatBlockedEmailMessage(saveResp?.data?.data));

            setPendingAction(() => () => {
              afterSave();
            });

            setOpenPopup(true);
            setLoder(false);
            return;
          }

          if (isInvalidEmail) {
            toast.error(
              "Unable to send the email because the recipient's email address is invalid or blocked.",
              {
                position: "top-right",
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: "light",
              }
            );
          }

          setLoder(false);
          afterSave();

          // setPqUserRequest(true);
          // setResetButtons(!resetButtons);
          // setNewInfo(modifiedData);
          // setIsSaved(true);
          // setTimeout(() => {
          //   setIsSaved(false);
          // }, 6000)
        }
        else {
          toast.error(saveResp?.data?.data, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
        setLoder(false);
      }
    })();
  }

  //Clear Form
  function ClearAllFormFields(val, data) {
    setLoder(true);
    val = +val;
    if (val === 1) {
      if (!isFieldsValidated()) {
        setLoder(false);
        return false;
      }
    }
    setSaveState({ status: "inProgress" });
    (async () => {
      let subSectionDetail = subSections?.find((r) => r?.id == subSectionId);
      let isSubsectionCompleted = subSectionDetail?.isSubSectionCompleted;
      let subSectionType = subSectionDetail?.SubsectiontypeCondition;
      let details = [];
      if (subSectionType == "ERIClientSelection") {
        details.push({
          subSectionId: 0,
          isSubSectionCompleted: isSubsectionCompleted,
          subSectionTypeCondition: subSectionType,
          isFinancialAnalytics: true,
          userInputsList: eriUserResponse?.unLockedClients?.map((r) => {
            return {
              UserInputRecId: 0,
              questionColumnId: 0,
              userInput: r?.value,
              oldUserInput: "",
              referenceid: 0,
            };
          }),
        });
      } else {
        details = data?.subSectionDetails?.map((r) => {
          return {
            subSectionId: r?.subSectionid,
            isSubSectionCompleted: isSubsectionCompleted,
            subSectionTypeCondition: r?.subSectionTypeCondition,
            isFinancialAnalytics: true,
            userInputsList: r?.subSectionQuestions?.flatMap((r) =>
              r?.questionColumns?.flatMap((r) => {
                return {
                  UserInputRecId: r?.preQualRecId,
                  questionColumnId: r?.columnId,
                  userInput: r?.answer,
                  oldUserInput: "",
                  referenceid: 0,
                };
              })
            ),
          };
        });
      }

      let _pqId = +PQID;
      if (_pqId === 0) {
        _pqId = +params.get("pqid");
        if (_pqId === 0) {
          alert("Invalid PqId");
          return;
        }
      }

      const pqUserInputVModel = {
        insertType: 3,
        preQualificationId: _pqId, //TODO:-- Convert String to Integer
        isSectionCompleted: IsSectionCompleted,
        sectionID: Secid,
        sectionType: SectionType,
        isNotifyFV: val == 1 ? true : false,
        userInputsModelList: details,
      };

      const saveResp = await axios.post(
        "Prequalification/SaveUserInputForPQ",
        pqUserInputVModel
      );
      setSaveState(saveResp?.data?.data);

      const afterClear = () => {
        setIsSaved(true);
        setPqUserRequest(true);
        LocationSectionReset();

        setTimeout(() => {
          setIsSaved(false);
        }, 6000);
      };

      if (saveResp?.data?.data == "Saved Successfully" || saveResp?.data?.data == "Success") {
        toast.success(saveResp?.data?.data, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setLoder(false);
        afterClear();

        // setIsSaved(true);
        // setPqUserRequest(true);
        // LocationSectionReset();
        // setTimeout(() => {
        //   setIsSaved(false);
        // }, 6000)
      } else {
        const hasBlockedEmails = saveResp?.data?.data?.includes("BlockedEmails:");
        const isInvalidEmail = saveResp?.data?.data == "Invalid Email";

        if (hasBlockedEmails || isInvalidEmail) {

          // Wait for OK button
          if (hasBlockedEmails) {
            setPopupMessage(formatBlockedEmailMessage(saveResp?.data?.data));

            setPendingAction(() => () => {
              afterClear();
            });

            setOpenPopup(true);
            setLoder(false);
            return;
          }

          if (isInvalidEmail) {
            toast.error(
              "Unable to send the email because the recipient's email address is invalid or blocked.",
              {
                position: "top-right",
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: "light",
              }
            );
          }

          setLoder(false);
          afterClear();

          // setIsSaved(true);
          // setPqUserRequest(true);
          // LocationSectionReset();
          // setTimeout(() => {
          //   setIsSaved(false);
          // }, 6000)
        }
        else {
          toast.error(saveResp?.data?.data, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
        setLoder(false);
      }

    })();
  }
  //


  function markSectionAsCompleted(value) {
    CompleteContinue();
  }
  //Finalize And Submit val
  const [FinalizeUserText, setFinalizeUserText] = useState("");
  const [FinalizeUserId, setFinalizeUserId] = useState("");
  const [FinalizeUserCheck, setFinalizeUserCheck] = useState("");
  const FinalizeUserIdAs = (id) => {
    setFinalizeUserId(id);
  }

  const FinalizeUserIdAsCompleter = (val, data) => {
    setFinalizeUserText(data);
    setFinalizeUserCheck(val);

    //console.log(val, data);
  }

  const [FinalizeAndSubmit, setFinalizeAndSubmit] = useState();


  function CompleteContinue(completeAllSubSections = true) {
    // if (isFieldsValidated()) {
    const refreshSectionsFlag = true;
    const cur = subSections?.find((f) => f?.id === subSection?.id);
    const next = subSections[subSections?.indexOf(cur) + 1];
    if (TotPay != null) {
      axios
        .post("Prequalification/GetPaymentURLs", Paymentdone)
        .then((resp) => {
          if (resp?.data?.data?.paymentReceived == true) {
            setReloader(resp?.data?.data?.paymentReceived); // ABDUL FEE CAP END
            dataload(resp?.data?.data?.paymentReceived); // ABDUL FEE CAP END
            (async () => {
              const details = {
                pqId: +PQID,
                templateSecId: Secid,
                isSectionCompleted: IsSectionCompleted,
                sectionType: SectionType,
              };
              const data = await axios.post(
                "Prequalification/AddCompletedSubSectionForPQ",
                details
              );
              if (data?.data?.data == "Success") {
                toastNotify(data?.data?.data, true);
                if (next) {
                  setScrollTabIntoView(true);
                  setSubSectionId(next?.id);
                  setNextId(next?.id);
                  setResetButtons(!resetButtons);


                } else {
                  setNextSection(refreshSectionsFlag);
                }
              } else {
                toastNotify(data?.data?.data, false);
              }
            })();
          } else {
            if (!hasLocationData) {
              toastNotify(
                "Please add at least one location for each client you selected in the General Information section",
                false
              );
              return;
            }
            if (next) {
              setScrollTabIntoView(true);
              setSubSectionId(next?.id);
              setNextId(next?.id);
              setResetButtons(!resetButtons);
            } else {
              setNextSection(refreshSectionsFlag);
            }
          }
        });
    } else {
      if (FinalizeUserText == 2 && FinalizeUserCheck == 2) {
        toastNotify("Please check the checkbox by confirming finalize (and) type your full name exactly as it appears in the section above", false);
      } else if (FinalizeUserText == 2) {
        toastNotify("Type your full name exactly as it appears in the section above", false);
      } else if (FinalizeUserCheck == 2) {
        toastNotify("Please check the checkbox by confirming finalize ", false);
      } else {
        (async () => {
          setFinalizeAndSubmit(true);
          const details = {
            pqId: +PQID,
            templateSecId: Secid,
            templateSubSecId: subSectionId,
            isSectionCompleted: IsSectionCompleted,
            sectionType: SectionType,
            completeSingleSubSection: !completeAllSubSections,
          };

          const cur = subSections?.find((f) => f?.id === subSection?.id);
          const next = subSections?.[subSections?.indexOf(cur) + 1];

          const data = await axios.post(
            "Prequalification/AddCompletedSubSectionForPQ",
            details
          );
          if (data?.data?.data == "Success") {
            if (SectionType == "SitePrequalification") {
              LocationSectionReset();
            }
            //toastNotify(data?.data?.data, true);
            //Vendor  "Finalize And Submit" Functionality ...
            if (FinalizeUserText == 1 && FinalizeUserCheck == 1) {

              toastNotify(data?.data?.data, true);
              setFinalizeAndSubmit(false);
              FinalizePopUpOpen(true);
              // const res = await axios.post("Prequalification/FinalizeAndSubmitPQ?pqId=" + PQID + "&sectionId=" + Secid + "&userIdAsCompleter=" + FinalizeUserId)
              // if (res?.data?.data == "Success") {
              //   toastNotify(res?.data?.data, true);
              //   setFinalizeAndSubmit(false);
              //   FinalizePopUpOpen(true);
              // } else {
              //   toastNotify(res?.data?.data, false);
              // }
            }
            //..
            if (next) {
              setScrollTabIntoView(true);
              setSubSectionId(next?.id);
              setNextId(next?.id);
              setResetButtons(!resetButtons);
              //store next id in context API & refresh subsections
              questionnaireStore?.setCurrentSubSectionId(next?.id);
              setRefresh(!Refresh);
            } else {
              //setNextSection(refreshSectionsFlag);
              setNextSection(refreshSectionsFlag, true);
            }

          } else {
            toastNotify(data?.data?.data, false);
            setFinalizeAndSubmit(false);
          }
        })();
      }
    }
    // }
  }

  const HandlePayment = (val) => {
    setTpaymentdone(val);
  };
  const HandlePay = (val) => {
    setTotPay(val);
  };

  const [NoMQuestions, setNoMQuestions] = useState('');
  const [hasEditAccess, setHaseditAccess] = useState();
  const Nomandatoryfield = (val) => {
    setNoMQuestions(val);
  }

  const EditAccess = (val) => {
    setHaseditAccess(val)
  }
  const SkipPay = (val) => {
    setskippedPayment(val);
  };
  const SkipPay1 = (val) => {
    setskippedPayment1(val);
  };
  const SkipPay2 = (val) => {
    setskippedPayment2(val);
  };
  const [Triggersitch, setTriggerSwitch] = useState();
  const Triger = (val) => {
    setTriggerSwitch(val);
  };
  const Footerid = subSections?.length - 1;
  const updateSubSectionVisibility = (
    _subSectionsToHide,
    _subSectionsToShow
  ) => {
    if (_subSectionsToHide?.length > 0) {
      subSections?.forEach((subSection) => {
        if (_subSectionsToHide?.some((id) => id === subSection?.id)) {
          subSection.isHide = true;
        }
      });
    }

    if (_subSectionsToShow?.length > 0) {
      subSections?.forEach((subSection) => {
        if (_subSectionsToShow?.some((id) => id === subSection?.id)) {
          subSection.isHide = false;
        }
      });
    }
    questionnaireStore?.setCurrentSubSectionId(subSectionId);
    setSubSections(subSections);
    setUpdateSubSectionsVisibility(true);
  };

  const handleClose = () => {
    setShowPrompt(false);
  }

  //For Reset Form
  const [modHistory, setModHistort] = useState([]);
  const [ResetInformation, setResetInformation] = useState([]);
  const [intialload, setintailLoad] = useState([]);
  useEffect(() => {
    setModHistort(prevHistory => [...prevHistory, NewInfo]);
    const Previously = modHistory?.[modHistory?.length - 1];
    if (isSaved) {
      setResetInformation(NewInfo);
    } else {
      setResetInformation(Previously);
    }
  }, [NewInfo])
  //*
  // useEffect(() => {

  //   setTimeout(() => {

  //     setintailLoad(false);
  //   }, 2000);
  // }, [])


  return (
    <>
      <ToastContainer />




      <Dialog open={OpenPopup} onClose={() => setOpenPopup(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Email Status</DialogTitle>

        <DialogContent dividers>
          <Typography sx={{ fontWeight: 600, mb: 5 }}>
            {popupMessage?.description}
          </Typography>

          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Paper
                elevation={0}
                sx={{
                  p: 2,
                  border: "1px solid #e0e0e0",
                  borderRadius: 2,
                  height: "100%"
                }}
              >
                <Typography variant="subtitle1" sx={{ fontWeight: 700, color: "error.main", mb: 1 }}>
                  Blocked Recipients
                </Typography>

                <List dense disablePadding>
                  {popupMessage?.blockedEmails?.map((email, index) => (
                    <ListItem key={index} disableGutters sx={{ alignItems: "flex-start", py: 0.5 }}>

                      <Box sx={{ width: 16, flexShrink: 0, fontSize: "1rem", lineHeight: 1.5 }}>
                        •
                      </Box>

                      <Typography variant="body2" sx={{ flex: 1, whiteSpace: "normal", overflowWrap: "break-word", wordBreak: "break-word" }}>
                        {email}
                      </Typography>

                    </ListItem>
                  ))}
                </List>
              </Paper>
            </Grid>

            <Grid item xs={12} md={6}>
              <Paper
                elevation={0}
                sx={{
                  p: 2,
                  border: "1px solid #e0e0e0",
                  borderRadius: 2,
                  height: "100%"
                }}
              >
                <Typography variant="subtitle1" sx={{ fontWeight: 700, color: "success.main", mb: 1 }}>
                  Recipients
                </Typography>

                <List dense disablePadding>
                  {popupMessage?.unBlockedEmails?.map((email, index) => (
                    <ListItem key={index} disableGutters sx={{ alignItems: "flex-start", py: 0.5 }}>

                      <Box sx={{ width: 16, flexShrink: 0, fontSize: "1rem", lineHeight: 1.5 }}>
                        •
                      </Box>

                      <Typography variant="body2" sx={{ flex: 1, whiteSpace: "normal", overflowWrap: "break-word", wordBreak: "break-word" }}>
                        {email}
                      </Typography>

                    </ListItem>
                  ))}
                </List>

              </Paper>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
          <Btn
            variant="contained"
            className="login-button-request"
            onClick={() => {
              setOpenPopup(false);

              if (pendingAction) {
                pendingAction();
                setPendingAction(null);
              }
            }}
          >
            OK
          </Btn>
        </DialogActions>
      </Dialog>


      <Dialog open={showResetConfirm} onClose={() => setShowResetConfirm(false)} maxWidth="xs" >
        <DialogTitle sx={{ fontWeight: 600, textAlign: "center" }}>
          Reset Form
        </DialogTitle>
        <DialogContent >
          <Typography sx={{ mt: 1, mb: 2, textAlign: "center", fontSize: "15px" }}>
            Are you sure you want to reset all answers?
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", pb: 2, paddingLeft: "25px", paddingRight: "25px" }}>
          <Btn
            onClick={() => setShowResetConfirm(false)}
            variant="contained"
            sx={{

              backgroundColor: "#EAF4FF",
              color: "#1A73E8",
              textTransform: "none",
              width: "100%",
              paddingTop: "15px",
              paddingRight: "20px",
              paddingLeft: "20px",
              paddingBottom: "15px",
              boxShadow: "none",
              '&:hover': {
                backgroundColor: "#d2e9ff"
              }
            }}
          >
            Cancel
          </Btn>
          <Btn
            onClick={() => {
              setClearForm({});
              setShowResetConfirm(false);
            }}
            variant="contained"
            sx={{
              width: "100%",
              backgroundColor: "#1A73E8",
              color: "#fff",
              paddingTop: "15px",
              paddingRight: "20px",
              paddingLeft: "20px",
              paddingBottom: "15px",
              textTransform: "none",

              boxShadow: "none",
              '&:hover': {
                backgroundColor: "#1669c1"
              }
            }}
          >
            Reset
          </Btn>
        </DialogActions>
      </Dialog>

      {showPrompt && (
        <Dialog open={showPrompt} onClose={handleClose} >
          <DialogTitle>Please select atleast one client</DialogTitle>
          <DialogActions className="w-100 d-flex">
            <Btn onClick={handleClose} sx={{ minHeight: "39px", minWidth: "90px" }} className="shadow-none " variant="contained" color="primary" autoFocus>
              OK
            </Btn>
          </DialogActions>
        </Dialog>
      )}
      {/* Exception&Probation section loder issue ----Start*/}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={Loder}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {/* Exception&Probation section loder issue ----End*/}
      {loading && false ? (
        <LoadingSpinner />
      ) : error ? (
        <ErrorAlert severity="error" message={error} />
      ) : (
        <SectionTemplate
          className="questionnaire-template"
          modifiedData={modifiedData}
          IsSectionCompleted={IsSectionCompleted}
          navProps={{
            ...subSectionNavProps,
            selected: subSectionId,
          }}
          NextId={NextId}
        >
          {/* {subSection?.id == subSections[0]?.id ? (
            <Box
            sx={{
              backgroundColor: "#fff",
              padding: "25px",
              marginbottom: "20px",
            }}
            >
              <div style={{ marginBottom: "10px", fontWeight: "bold" }}>
                {HeaderTitle}
              </div>
              <div
                style={{ overflowX: "hidden" }}
                dangerouslySetInnerHTML={{ __html: HeaderContent }}
              />
            </Box>
          ) : (
            ""
            )} */}
          {/* <SectionNote section={subSection?.subSectionNotes ?? ""} /> */}
          {subSection?.component ? (
            <subSection.component
              SectionCompleted={IsSectionCompleted}
              dataUrl={`${dataUrl}/${subSection?.id}`}
              setShowFormButtons={setShowFormButtons}
              reset={reset}
              resetButtons={resetButtons}
              hasUnsavedChanges={hasUnsavedChanges}
              setReset={setReset}
              Secid={Secid}
              SubId={subSection?.id}
              IsSubSectionCompleted={subSection?.isSubSectionCompleted}
              SectionType={SectionType}
              SubSectionTypeCondition={subSection?.SubsectiontypeCondition}
              setModifiedData={setModifiedData}
              Validate={ValidationsErrors}
              RemoveRequiredHiddenFields={RemoveRequiredHiddenFields}
              // Required={Validate}
              RESETQUESTIONS={ResetQuestions}
              title={subSection?.title}
              content={subSection?.content}
              PAY={HandlePay}
              NotMandatory={Nomandatoryfield}
              Skippedpayment={HandlePayment}
              Editaccess={EditAccess}
              SKIP={SkipPay}
              SKIP1={SkipPay1}
              SKIP2={SkipPay2}
              Skipped={skippedPayment}
              SubSectionName={subSection?.text}
              Triger={Triger}
              VIEWMODE={VIEWMODE}
              QuestionReset={questionReset}
              PQCLIENTID={PQCLIENTID}
              ClientTemplate={ClientTemplate}
              SAVE={Save}
              updateSubSectionVisibility={updateSubSectionVisibility}
              validateAllSubSectionQuestions={validateAllSubSectionQuestions}
              setHasLocationData={setHasLocationData}
              pqId={PQID}
              languageId={languageId}
              setEriUserResponse={setEriUserResponse}
              markSectionAsCompleted={markSectionAsCompleted}
              pqStartDate={pqStartDate}
              pqClientVendorRef={pqClientVendorRef}
              vendornameDownload={venName}
              FinalizeUserIdAsCompleter={FinalizeUserIdAsCompleter}
              FinalizeUserIdAs={FinalizeUserIdAs}
              PqStatusID={PqStatusID}
              PqClientName={PqClientName}
              IsMultiple={IsMultiple}
              ResetInformation={ResetInformation}
              PqUserRequest={PqUserRequest}
              setPqUserRequest={setPqUserRequest}
              setSaveButtionHiden={setSaveButtionHiden}
              setClientIds={setClientIds}
              setWithoutmodifiedData={setWithoutmodifiedData}
              Information={setInformation}
              LocationSectionReset={LocationSectionReset}
              ClearFields={ClearForm}//Clear Form
              ClearAllFormFields={ClearAllFormFields}//Clear Form
            />
          ) : (
            <Box>{subSection?.text}</Box>

          )}
          {subSection?.id == subSections[Footerid]?.id ? (
            <Box sx={{ padding: "5px", marginTop: "20px" }}>
              <b
                className="w-100 my-2 rounded"
                style={{ color: "#667085" }}
              >
                {/* {section?.HeaderTitle} */}
                <div
                  style={{ overflowX: "hidden" }}
                  dangerouslySetInnerHTML={{
                    __html: SectionFooterTitle,
                  }}
                />
              </b>
              <div
                style={{ overflowY: "hidden" }}
                dangerouslySetInnerHTML={{ __html: FooterContent }}
              />
            </Box>
          ) : (
            ""
          )}
          {saveState?.status === "error" && (
            <ErrorAlert severity="error" message={saveState?.message} />
          )}
          {subSection ? (
            <Box
              className="questionnaire-template-buttons buttons row"
              hidden={Triggersitch}
            >
              {/* {JSON.stringify(subSections)} */}
              <Box className="col-4">
                {/* <Button
                  role="primary"
                  size="small"
                  label="Previous"
                  onClick={setPrevActive}
                  hidden={disabledButtons?.prev}
                /> */}
              </Box>
              <Box className="col-4 text-center" hidden={!Information}>
                {/* {JSON.stringify(disabledButtons)} */}
                {showFormButtons && (
                  <>
                    <Button
                      role="primary"
                      size="small"
                      label="Save"
                      onClick={Save}
                      disabled={disabledButtons?.save}
                      style={{
                        display:
                          subSection?.SubsectiontypeCondition == "UserOrganization" || subSection?.SubsectiontypeCondition == "UserDetailsForEP" || subSection?.SubsectiontypeCondition == "PrequalComments" ? "none" : ""
                      }}
                    // trailingComponent={
                    //   saveState?.status === "inProgress" && (
                    //     <CircularProgress size="1rem" />
                    //   )
                    // }
                    />

                    <Button
                      role="secondary"
                      size="small"
                      label="Cancel"
                      onClick={() => setReset({})}
                      disabled={disabledButtons?.cancel}
                      style={{
                        display:
                          subSection?.SubsectiontypeCondition == "UserOrganization" || subSection?.SubsectiontypeCondition == "UserDetailsForEP" || subSection?.SubsectiontypeCondition == "PrequalComments" ? "none" : ""
                      }}
                    />
                  </>
                )}
                {subSection?.SubsectiontypeCondition ==
                  "PrequalificationFinalize" ? (
                  <>
                    {getOrgType() == "Vendor" ? (
                      <>
                        {PqStatusID == 3 || PqStatusID == 15 || PqStatusID == 7 ? (
                          <Button
                            disabled={FinalizeAndSubmit}
                            role="primary"
                            size="small"
                            label="Finalize & Submit"
                            onClick={CompleteContinue}
                            hidden={
                              !hideCompleteAndContinue(
                                subSection?.SubsectiontypeCondition
                              ) || !getOrgType()
                            }
                          />
                        ) : (
                          <Button
                            role="primary"
                            size="small"
                            label="Continue To Dashboard "
                            onClick={() => navigate("/DashBoard")}
                            hidden={
                              !hideCompleteAndContinue(
                                subSection?.SubsectiontypeCondition
                              ) || !getOrgType()
                            }
                          />
                        )}
                      </>
                    ) : getOrgType() == "Client" || "Admin" ? (
                      <Button
                        role="primary"
                        size="small"
                        label="Continue To Dashboard "
                        onClick={() => navigate("/DashBoard")}
                        hidden={
                          !hideCompleteAndContinue(
                            subSection?.SubsectiontypeCondition
                          )
                        }
                      />
                    ) : (
                      ""
                    )}
                  </>
                ) : (
                  ""
                )}


                {subSection?.SubsectiontypeCondition == "UserOrganization" || subSection?.SubsectiontypeCondition == "UserDetailsForEP" ? (
                  <Button
                    role="primary"
                    size="small"
                    label="Continue"
                    onClick={() => CompleteContinue(false)}
                    hidden={
                      !hideCompleteAndContinue(
                        subSection?.SubsectiontypeCondition
                      ) ||
                      subSection?.SubsectiontypeCondition ==
                      "PrequalificationFinalize" || getOrgType() == "Client" ||
                      TotPay // TO DO Sandeep

                    }
                  />
                ) : (
                  <Button
                    role="primary"
                    size="small"
                    label="Complete & Continue"
                    onClick={CompleteContinue}
                    hidden={
                      !hideCompleteAndContinue(
                        subSection?.SubsectiontypeCondition
                      ) ||
                      subSection?.SubsectiontypeCondition ==
                      "PrequalificationFinalize" ||
                      // subSection?.SubsectiontypeCondition == "LocationApproval" || //for admin
                      TotPay
                    }
                    style={{
                      display: getOrgType() == "Client" && (subSection?.SubsectiontypeCondition == "SitePrequalification" ||
                        subSection?.SubsectiontypeCondition == "SupportingDocument") ? "none" : ""
                    }}
                    disabled={subSections?.filter(item => !item?.isHide)[subSections?.filter(item => !item?.isHide)?.length - 1]?.id === subSectionId &&
                      subSections?.filter(item => !item?.isHide)?.slice(0, -1)?.some(item => item?.isSubSectionCompleted === false) ? true : false}
                  />

                )}
                {/* <Button
                  role="primary"
                  size="small"
                  label="Next"
                  style={{ display: !VIEWMODE ? VIEWMODE : (NoMQuestions != true ? "none" : "") }} //No Questions For
                  onClick={setNextActive}
                  hidden={
                    disabledButtons.next ||
                    hideCompleteAndContinue(subSection?.SubsectiontypeCondition)
                  }
                /> */}

                {/* No Questions For */}
                {/* <div >
                  <Button
                    role="primary"
                    size="small"
                    label={hasEditAccess == false ? "Next" : "Save and Continue"}
                    onClick={hasEditAccess == false ? setNextActive : EmptySubsectionAndNonmandatryQuestions}

                    style={{
                      display: NoMQuestions != true && !hideCompleteAndContinue(
                        subSection?.SubsectiontypeCondition
                      ) ? "" : "none"
                    }}
                    hidden={SaveButtionHiden || hasUnsavedChanges || !VIEWMODE}

                  />
                </div> */}

                {/* 
                {JSON.stringify(subSections.filter(item => !item.isHide)[subSections.filter(item => !item.isHide).length - 1]?.id === subSectionId &&
                      subSections.filter(item => !item.isHide).slice(0, -1).some(item => item.isSubSectionCompleted === false))} */}

                {getOrgType() == "Client" && subSection?.SubsectiontypeCondition == "ERIClientSelection" && subSections[subSections?.length - 1]?.id == subSectionId ? "" :
                  <Button
                    role="primary"
                    size="small"
                    label={subSections?.filter(item => !item?.isHide)[subSections?.filter(item => !item?.isHide)?.length - 1]?.id != subSectionId ? "Save & Continue" : "Complete & Continue"}
                    //onClick={NoMQuestions == true && modifiedData ? SaveContinue : EmptySubsectionAndNonmandatryQuestions}
                    onClick={SaveContinue}
                    hidden={
                      hideCompleteAndContinue(
                        subSection?.SubsectiontypeCondition
                      ) ||
                      subSection?.SubsectiontypeCondition ==
                      "PrequalificationFinalize" ||
                      subSection?.SubsectiontypeCondition == "PrequalComments" ||
                      hasEditAccess == false || ((getOrgType() == "Admin" ? (VIEWMODE == false || subSection?.editAccess == false) : getOrgType() == "Vendor" ? (!VIEWMODE == true && subSection?.editAccess == false) : (VIEWMODE == false || subSection?.editAccess == false))) || SaveButtionHiden || TotPay // TO DO Sandeep

                    }
                    // style={{display:subSections[subSections?.length - 1]?.id == subSectionId&&(subSections?.slice(0, -1)?.some(item => item.isSubSectionCompleted === false))?"none":""}}
                    disabled={subSections?.filter(item => !item?.isHide)[subSections?.filter(item => !item?.isHide)?.length - 1]?.id === subSectionId &&
                      subSections?.filter(item => !item?.isHide).slice(0, -1)?.some(item => item?.isSubSectionCompleted === false) ? true : false}
                  />

                }
                {subSection?.SubsectiontypeCondition == "PrequalComments" ?
                  <Button
                    role="primary"
                    size="small"
                    label="Save & Continue"
                    onClick={EmptyPqComments}
                  />
                  : ""}
                {/* <Button
                  role="primary"
                  size="small"
                  label="Next"
                  style={{ display: !VIEWMODE ? VIEWMODE : (NoMQuestions != true ? "none" : "") }} // No Questions For
                  onClick={setNextActive}
                  hidden={
                    !disabledButtons.next ||
                    hideCompleteAndContinue(
                      subSection?.SubsectiontypeCondition
                    ) ||
                    hasUnsavedChanges
                    || subSection?.SubsectiontypeCondition == "PrequalComments" //For Empty subsection 
                  }
                /> */}
                {showFormButtons && (
                  <Button
                    hidden={getOrgType() != "Admin" || subSection?.SubsectiontypeCondition == "ERIClientSelection"}
                    role="secondary"
                    size="small"
                    label="Reset"
                    onClick={() => setShowResetConfirm(true)}
                  />
                )}
              </Box>

            </Box>

          ) : (
            <Delayed waitBeforeShow={2000} message="">
              <ErrorAlert severity="warning" message="Nothing to show!" />
            </Delayed>
          )}
        </SectionTemplate>
      )}
    </>
  );
}